/* tslint:disable */
/* eslint-disable */
/**
 * Location check service API
 * Service to centralise business area handling for multiple depending services.
 *
*/

import { exists, mapValues } from '../runtime';
import type { PositionRto } from './PositionRto';
import {
    PositionRtoFromJSON,
    PositionRtoFromJSONTyped,
    PositionRtoToJSON,
} from './PositionRto';

/**
 * 
 * @export
 * @interface AirportZoneRto
 */
export interface AirportZoneRto {
    /**
     * 
     * @type {string}
     * @memberof AirportZoneRto
     */
    zoneName?: string;
    /**
     * 
     * @type {string}
     * @memberof AirportZoneRto
     */
    zoneType?: string;
    /**
     * 
     * @type {PositionRto}
     * @memberof AirportZoneRto
     */
    centerPosition?: PositionRto;
    /**
     * 
     * @type {number}
     * @memberof AirportZoneRto
     */
    locationId?: number;
    /**
     * 
     * @type {string}
     * @memberof AirportZoneRto
     */
    iataAirportCode?: string;
}

/**
 * Check if a given object implements the AirportZoneRto interface.
 */
export function instanceOfAirportZoneRto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function AirportZoneRtoFromJSON(json: any): AirportZoneRto {
    return AirportZoneRtoFromJSONTyped(json, false);
}

export function AirportZoneRtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): AirportZoneRto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'zoneName': !exists(json, 'zoneName') ? undefined : json['zoneName'],
        'zoneType': !exists(json, 'zoneType') ? undefined : json['zoneType'],
        'centerPosition': !exists(json, 'centerPosition') ? undefined : PositionRtoFromJSON(json['centerPosition']),
        'locationId': !exists(json, 'locationId') ? undefined : json['locationId'],
        'iataAirportCode': !exists(json, 'iataAirportCode') ? undefined : json['iataAirportCode'],
    };
}

export function AirportZoneRtoToJSON(value?: AirportZoneRto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'zoneName': value.zoneName,
        'zoneType': value.zoneType,
        'centerPosition': PositionRtoToJSON(value.centerPosition),
        'locationId': value.locationId,
        'iataAirportCode': value.iataAirportCode,
    };
}

